// Components==============
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import ToggleButton from 'components/UI/ToggleButton/ToggleButton';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { HomeContext } from 'screens/Home/Home';
import { initialPulse, pulse } from 'utilities/framerAnimations';
import { MenuContext } from '../../Menu';
import Popup from '../Popup/Popup';
import Back from './components/Back';
import Front from './components/Front';
import Video from './components/Video';
import './Dog.module.scss';
// =========================

export type CheatSheetBoxProps = {
    text: string;
    children?: React.ReactNode;
    back?: boolean;
};

export type CheatSheetPlayerProps = {
    text: string | React.ReactElement;
};
type viewOptions = 'front' | 'back' | 'video';

export default function Dog() {
    const { select, selected, setMenuPointer } = useContext(MenuContext);

    const [view, setView] = useState<viewOptions>('front');
    const [videoId, setVideoId] = useState<string>('');

    function setVideo(videoIdProp: string) {
        setView('video');
        setVideoId(videoIdProp);
    }

    const { setWelcomeY, welcomeSequence } = useContext(HomeContext);

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (welcomeSequence === 'spiekbrief') {
            setWelcomeY(`${ref?.current?.offsetTop!}px`);
        }
    }, [welcomeSequence]);

    return (
        <div styleName="wrapper" ref={ref}>
            <motion.button
                animate={
                    welcomeSequence === 'spiekbrief' ? pulse : initialPulse
                }
                initial={initialPulse}
                onClick={(e) => {
                    select('dog');
                    setMenuPointer(e);
                    setView('front');
                }}
                type="button"
            >
                <img alt="dog icon" src="/images/menu/icon-dog.svg" />
            </motion.button>
            {selected === 'dog' && (
                <Popup>
                    <div styleName="top">
                        <div styleName="left">
                            {view === 'video' && (
                                <motion.div
                                    whileHover={{ scale: 1.03 }}
                                    whileTap={{ scale: 0.97 }}
                                    onClick={() => {
                                        setView('front');
                                    }}
                                    styleName="back-button"
                                >
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </motion.div>
                            )}
                            <h3>Spiekbrief</h3>
                        </div>
                        {view !== 'video' && (
                            <div styleName="right">
                                <Button
                                    lightgrey
                                    onClick={() => {
                                        setView('video');
                                        setVideoId(
                                            '9e4242440aad1b5b454d9d9808c0988c'
                                        );
                                    }}
                                >
                                    Over spiek
                                    <FontAwesomeIcon icon={faPlay} />
                                </Button>
                                <ToggleButton
                                    onClick={() =>
                                        view === 'front'
                                            ? setView('back')
                                            : setView('front')
                                    }
                                    value1="Eén klankgroep"
                                    value2="Meer klankgroepen"
                                />
                            </div>
                        )}
                    </div>
                    <div styleName="content">
                        {view === 'front' && <Front setVideo={setVideo} />}
                        {view === 'back' && <Back setVideo={setVideo} />}
                        {view === 'video' && <Video videoId={videoId} />}
                    </div>
                </Popup>
            )}
        </div>
    );
}
